<template>
	<div class="vue-head-menu">
		<el-divider v-if="title">{{title}}</el-divider>
		<div class="item" v-for="item in menu" :key="item.title">
			<div class="represent">{{item.title}}</div>
			<div class="tail">
				<div class="tail-item" v-for="item2 in item.children" v-if="item.children" @click="handlerClick">
					<el-menu-item :index="item2.url" v-if="item2.target=='router'">
						{{item2.title}}
					</el-menu-item>
					<a :href="item2.url" target="_blank" v-else-if="item2.target=='link'">{{item2.title}}</a>
					<span v-else>{{item2.title}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			menu: {
				type: Array
			},
			title: {
				type: String
			}
		},
		data() {
			return {}
		},
		methods: {
			handlerClick() {
				this.$emit('click')
			}
		}
	}
</script>

<style >
	.vue-head-menu {
		width: 800px;
		padding: 5px 20px;
		font-size: 15px;
	}
	
	.vue-head-menu .item {
		display: grid;
		grid-template-columns: 130px auto;
	
	}
	
	.vue-head-menu .represent,
	.vue-head-menu .tail {
		display: inline-block;
	}
	
	.vue-head-menu .represent {
		font-weight: 700;
		line-height: 36px;
	}
	
	.vue-head-menu .tail {
		color: #333;
		font-size: 14px;
		margin-right: 20px;
		line-height: 36px;
		display: flex;
		flex-wrap: wrap;
	}
	
	.vue-head-menu .tail >div {
		cursor: pointer;
		display: inline;
		margin-right: 20px;
		line-height: 26px;
	}
	
	.vue-head-menu .tail >div:hover {
		color: #6205b3;
		text-shadow: 1px 1px 1px #aaa;
	}
		
	.vue-head-menu .tail a {
		color: #333;
		text-decoration: none;
		line-height: 36px;
	}
	
	.vue-head-menu .tail a:hover {
		color: #6205b3;
		text-shadow: 1px 1px 1px #aaa;
	}
		
	.vue-head-menu .tail .el-menu-item {
		display: inline;
		color: #333 !important;
		font-size: 14px;
		padding: 0;
	}
	
	.vue-head-menu .tail .el-menu-item :hover {
		color: #6205b3 !important;
		text-shadow: 1px 1px 1px #aaa;
	}
	
	.vue-head-menu .el-divider__text.is-center {
		background-color: #f2f2f2;
		font-size: 18px;
		font-weight: bold;
	}
</style>
